import { createEvent, createStore, sample } from 'effector'
import { reloadUrl } from '~/entities/player/model'
import { entitiesPlayerTrailerModel } from '~/entities/player/trailer'

// Events driven by the adapter

/** 433 response detected; carries the parsed CSL value from the token. */
export const cslErrorDetected = createEvent<{ csl: number | null }>()

/** Player fired its Retry event (Try Again button clicked). */
export const retryAttempted = createEvent()

/** Playback resumed — retry succeeded. */
export const playbackStarted = createEvent()

/** User switched to different content. */
export const contentChanged = createEvent()

/** retryAttempted while a CSL error is active; drives reloadUrl. */
export const retryRequested = createEvent()

// Stores

/** Parsed CSL from the active 433; null if absent or no error. */
export const $csl = createStore<number | null>(null)
  .on(cslErrorDetected, (_, { csl }) => csl)
  .reset([playbackStarted, contentChanged])

/** Active 433 flag; needed when $csl is null but error is still present. */
const $isCslActive = createStore<boolean>(false)
  .on(cslErrorDetected, () => true)
  .reset([playbackStarted, contentChanged])

// retryAttempted → retryRequested: guarded by an active CSL error
sample({
  clock: retryAttempted,
  filter: $isCslActive,
  target: retryRequested,
})

// retryRequested → route-level URL reload
sample({
  clock: retryRequested,
  target: reloadUrl,
})

// CSL error detected on any player (main or background) → stop the trailer player.
sample({
  clock: cslErrorDetected,
  target: entitiesPlayerTrailerModel.stopTrailerFlow,
})

/** feature mounting. */
export const init = createEvent()
